import React, { useState } from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventoryBean,
  SkuBatchInventoryPageListPrintRequest,
  FabricStyleInAndOutStatisticsCriteriaBean,
  RestDailyInventoryTrackListRequest,
  DailyInventoryProcessTrackInquiryCriteriaBean,
  RestDailyInventoryProcessTrackListRequest,
} from "../ds/ds.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupInventoryAdjustmentModule,
  PopupInventoryTransferModule,
  PopupInvoiceModule,
  PopupLogisticReceiptModule,
  PopupPickTicketModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ReportService } from "../services/ReportService.js";
import { DEFAULT_WAREHOUSE } from "../ds/App_Constants.js";
import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
  NumberFormatInputbox,
  DatePickerComponent_adv,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import CustomTable from "../gui_components/CustomTable.js";
class LotBasedInventory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Lot Based Inventory In/Out Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      warehouses: [],

      criteria: new FabricStyleInAndOutStatisticsCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,

      isShowFabricStyleModule: false,
      isShowPurchaseReceiptModule: false,
      isShowInvoiceModule: false,

      isShowColorLookup: false,
      colorLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: true,
      isShowAutoCompleteFabricColorList: true,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",

      isDisableFields: false,
      isCollapsible_open: true,
      is3PL: false,
      fabricStyleData: new FabricStyleBean(),

      totalPages: 0,

      isShowReceivedQtyPopup: false,
      isShowShippedQtyPopup: false,

      isShowAlertLvl3: false,

      receiptLotDatas: new Array(),
      shippedLotDatas: new Array(),
    };
    this.fabricCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };

    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,

      this.state.is3PL ? "Item" : "FabricStyle"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";

    if (isEmptyString(data.fabricStyleCode)) {
      let errMsg = "Fabric is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }

    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
      moduleForPopup: [],
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";

    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";

    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowResetButton: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      isDisableFields: false,
      isShowClearCriteriaButton: true,

      fabricPageListForAutoCompleteList: new Array(),
      totalPages: 0,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowReceivePopupLvl1: isShowPopup,
    });
  };

  closeAlertModalCallBackLvl2 = (isShowPopup) => {
    this.setState({
      isShowReceivePopupLvl2: isShowPopup,
    });
  };

  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };

  /* --------------------------Fabric/Item Onchange -------------------------------- */
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.isShowAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.isShowAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        criteria.fabricStyleColorCode = "";
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readAndSetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    const criteria = this.state.criteria;
    const searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    searchCriteria.logisticCustomerCode = criteria.logisticCustomerCode;
    searchCriteria.logisticCustomerCode = criteria.customerCode;
    const pageList = new RestPageListBean();
    pageList.pageSize = 100;
    const input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStylePageList) &&
      !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let criteria = this.state.criteria;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
          // }
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readAndSetFabricStyleDetail(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteFabricList: showAutoCompleteList });
  };

  /* ----------------------------------Fabric Color ----------------------- */
  onFabricColourCodeChange = (e) => {
    this.state.isShowAutoCompleteFabricColorList = true;
    let fabricStyleColorCode = e.target.value;
    let isShowAutoCompleteFabricColorList =
      this.state.isShowAutoCompleteFabricColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.isShowAutoCompleteFabricColorList = false;
      let isShowAutoCompleteFabricColorList =
        this.state.isShowAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteFabricColorList: isShowAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      isShowAutoCompleteFabricColorList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (fabricStyleColorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == fabricStyleColorCode
        )
          skuBean = sku;
      });
    }
    criteria.fabricStyleColorCode = fabricStyleColorCode;
    this.setState({ criteria: criteria });
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  generatePDF = () => {
    // this.generateDailyInventoryTrackReport(1);
  };
  generateExcel = () => {
    // this.generateDailyInventoryTrackReport(2);
  };
  //   generateDailyInventoryTrackReport = (reportType) => {
  //     let criteria = this.state.criteria;
  //     criteria.companyCode = this.companyCode;
  //     let reportBean = new RestReportBean();
  //     reportBean.reportType = reportType;
  //     let pageInput = new RestPageListBean();
  //     // pageInput.pageSize = 20;
  //     // pageInput.currentPage = 1;
  //     let listRequest = new RestDailyInventoryTrackListRequest();
  //     listRequest.searchCriteria = criteria;
  //     listRequest.reportBean = reportBean;
  //     listRequest.pageInput = pageInput;
  //     this.setState({
  //       isShowProgressBarPopup: true,
  //       progressLoadingText: "Generating Report...",
  //     });
  //     if (reportBean.reportType == 1) {
  //       // if (
  //       //   SecurityAccessManager.SkuBatchInventoryInquiryPDFReport_IsAccessible()
  //       // ) {
  //       ReportService.generateDailyInvenotryPrintReport(
  //         listRequest,
  //         this.generateDailyInventoryTrackPageResponse,
  //         this.errorCallBack
  //       );
  //       // } else {
  //       //   this.inValidAccess(2);
  //       // }
  //     } else if (reportBean.reportType == 2) {
  //       // if (
  //       //   SecurityAccessManager.SkuBatchInventoryInquiryExcelReport_IsAccessible()
  //       // ) {
  //       ReportService.generateDailyInvenotryPrintReport(
  //         listRequest,
  //         this.generateDailyInventoryTrackPageResponse,
  //         this.errorCallBack
  //       );
  //       // } else {
  //       //   this.inValidAccess(3);
  //       // }
  //     }
  //   };
  //   generateDailyInventoryTrackPageResponse = (response) => {
  //     this.showErrorMessage(response.data);
  //     if (response.data != null && response.data.reportResult != null) {
  //       if (!isEmptyString(response.data.reportResult.reportFileID)) {
  //         let reportFilePath = response.data.reportResult.reportFileID;
  //         window.open(this.report_url + reportFilePath);
  //       }
  //     }
  //     this.setState({
  //       isShowProgressBarPopup: false,
  //       progressLoadingText: "",
  //     });
  //   };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    this.loadPage(this.state.totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.mode = 2;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (SecurityAccessManager.LotBasedInventoryInOutInquiry_IsAccessible()) {
      ReportService.getFabricStyleInAndOutStatisticsDetails(
        criteria,
        this.loadPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };

  loadPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inquiryResult != null) {
      let lotInventoryList = [];
      let inquiryDataList = response.data.inquiryResult;
      if (!isEmptyArray(response.data.inquiryResult.lotNumberDatas)) {
        lotInventoryList = response.data.inquiryResult.lotNumberDatas;
        this.setState({
          //   isShowPDFButton: true,
          isShowExcelButton: false,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: lotInventoryList,

        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  receivedQuantityResponse = (response) => {
    let receiptLotDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.receiptLotDatas))
        receiptLotDatas = response.data.inquiryResult.receiptLotDatas;
    }
    this.setState({
      receiptLotDatas: receiptLotDatas,
    });
  };
  receivedQtyClick = (e, val, rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = rowData.fabricStyleCode;
    criteria.fabricStyleColorCode = rowData.colorCode;
    criteria.lotNumber = rowData.lotNumber;
    // criteria.mode = 2;
    //   criteria.fabricStyleCode = this.state.fabricStyleData.code;
    ReportService.getPurchaseOrderReceiptRollLinesForLotNumber(
      criteria,
      this.receivedQuantityResponse,
      this.errorCallBack
    );

    this.setState({ isShowReceivedQtyPopup: true });
  };

  shippedQuantityResponse = (response) => {
    let shippedLotDatas = new Array();
    if (!isEmpty(response.data) && !isEmpty(response.data.inquiryResult)) {
      if (!isEmptyArray(response.data.inquiryResult.shippedLotDatas))
        shippedLotDatas = response.data.inquiryResult.shippedLotDatas;
    }
    this.setState({
      shippedLotDatas: shippedLotDatas,
    });
  };

  shippedQtyClick = (e, val, rowData) => {
    let criteria = new FabricStyleInAndOutStatisticsCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleCode = rowData.fabricStyleCode;
    criteria.fabricStyleColorCode = rowData.colorCode;
    criteria.lotNumber = rowData.lotNumber;
    ReportService.getInvoiceRollLinesForLotNumber(
      criteria,
      this.shippedQuantityResponse,
      this.errorCallBack
    );

    this.setState({ isShowShippedQtyPopup: true });
  };

  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyleCode",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-3")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Lot#", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.receivedQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.shippedQtyClick, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Difference", "differnceQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
    );
    return columns;
  };

  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };

  viewFabricModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricStyleModule: true,
        moduleForPopup: (
          <PopupFabricStyleModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewPRModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseReceiptModule: true,
        moduleForPopup: (
          <PopupPurchaseReceiptModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowInvoiceModule: true,
        moduleForPopup: (
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  receivedQuantityColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PR#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.viewPRModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll##", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Received", "receivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
    );

    return columns;
  };
  shippedQuantityColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Item#", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name#", "fabricStyleName", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Roll##", "rollNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Inventory#", "rollSkuNumber", true)
        .setStyleDetails("left", "", "", "wt-5", "wt-5")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Qty Shipped", "shippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-5", "wt-5")
    );

    return columns;
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl3: isDisplayed,
    });
  };
  closeAlertModalCallBackLvl3 = (isShowPopup) => {
    this.setState({
      isShowAlertLvl3: isShowPopup,

      isShowReceivedQtyPopup: isShowPopup,
      isShowShippedQtyPopup: isShowPopup,
    });
  };

  render() {
    const inquiryDataList = this.state.inquiryDataList;

    let totalPages = 0;
    totalPages = this.state.totalPages;

    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          showHideSecondHeader={this.showHideSecondHeader}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
        />

        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
          </div>
        )}

        {/*****************************Received Quantity popup **********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowReceivedQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"Received Quantity Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.receivedExcelButtonClick(e)}
          //     >
          //       Excel
          //     </Button>
          //   </div>
          // }
          content={
            <div>
              <CustomTable
                data={this.state.receiptLotDatas}
                columns={this.receivedQuantityColumns()}
                label={"Received Qty List"}
              />
            </div>
          }
        />

        {/*****************************Shipped Quantity popup **********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          isShowPopup={this.state.isShowShippedQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"Shipped Quantity Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl3}
              hideAlertCallBack={this.hideAlertCallBackLvl3}
            />
          }
          // headerButtonContainer={
          //   <div className="floatLeft">
          //     <Button
          //       className="header_buttons enterFocus"
          //       size="sm"
          //       onClick={(e) => this.shippedExcelButtonClick(e)}
          //     >
          //       Excel
          //     </Button>
          //   </div>
          // }
          content={
            <div>
              <CustomTable
                data={this.state.shippedLotDatas}
                columns={this.shippedQuantityColumns()}
                label={"Shipped List"}
              />
            </div>
          }
        />
        {/**************************  Module Popup *******************************/}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);

  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;

  const fabricCodeRef = props.fabricCodeRef;

  let isDisableFields = props.isDisableFields;
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const fabricEnterKeyEventHandler = (e) => props.fabricEnterKeyEventHandler(e);
  const displayAutoCompleteFabricList = (e) =>
    props.displayAutoCompleteFabricList(e);

  const onFabricColourCodeChange = (e) => props.onFabricColourCodeChange(e);

  const fabricColourEnterKeyEventHandler = (e) =>
    props.fabricColourEnterKeyEventHandler(e);

  const displayAutoCompleteFabricColorList = () =>
    props.displayAutoCompleteFabricColorList();

  return (
    <div>
      <div>
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            <FormLabel>Item</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={fabricCodeRef}
              name="fabricStyleCode"
              onChange={fabricCodeOnChange}
              value={criteria.fabricStyleCode}
              placeholder="item"
              lookupRequired={true}
              lookupHandler={props.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={fabricEnterKeyEventHandler}
              autoCompleteListData={props.fabricPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricList}
              showAutoCompleteList={props.isShowAutoCompleteFabricList}
              // disabled={isDisableFields}
              isMandatory={true}
              disabled={props.isDisableFields}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              onChange={onChange}
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onFabricColourCodeChange}
              //   onChange={onFabricColourCodeChange}
              name="fabricStyleColorCode"
              placeholder="color"
              value={criteria.fabricStyleColorCode}
              lookupRequired={props.isShowColorLookup}
              lookupHandler={props.colorLookupHandler}
              enterKeyEventHandler={fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricColorList}
              showAutoCompleteList={props.isShowAutoCompleteFabricColorList}
              disabled={!props.isShowColorLookup}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Lot#</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              name="lotNumber"
              onChange={onChange}
              value={criteria.lotNumber}
              placeholder="lotNumber"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}
function LotBasedInventoryInOutInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <LotBasedInventory {...props} name="" /> <br />
    </div>
  );
}

export default LotBasedInventoryInOutInquiry;
